import { UUID } from '@/types/types';
import { Vector2Tuple } from 'three';
import { SerializedModulesManager } from './managers/ModulesManager';
import { SerializedPlaygroundManager } from './managers/PlaygroundManager';
import { CreatorMeasurement, ModuleContextMenuData } from '@/types/creator';
import { SerializedMeasurementManager } from './managers/MeasurementManager';
import { SerializedProjectPlane } from './objects/ProjectPlane';
import { SerializedCameraController } from './controls/CameraController';

export enum RendererMode {
	SHAPES = 'SHAPES',
	CUSTOM_SHAPE_DRAWING = 'CUSTOM_SHAPE_DRAWING',
	MEASURING = 'MEASURING',
	MODULES = 'MODULES',
	PREVIEW = 'PREVIEW',
}

export enum UserDataObjectType {
	PROJECT = 'project',
	COLLIDABLE_OBJECT = 'collidable_object',
}

export enum UserDataProp {
	OBJECT_ID = 'object_id',
	OBJECT_TYPE = 'object_type',
}

export enum CustomObjectName {
	ZONE_OUTER = 'zone_outer',
}

export enum ThreeEvent {
	SELECT_MODULE = 'select_module',
	CALCULATE_SURFACE_AREA = 'calculate_surface_area',
	ZOOM_LEVEL = 'zoom_level',
	DISTANCE = 'distance',
	IS_DRAWING = 'is_drawing',
	SET_MEASUREMENTS = 'set_measurements',
	CONTEXT_MENU = 'context_menu',
}

export type ThreeEvents = {
	[ThreeEvent.SELECT_MODULE]: UUID | null;
	[ThreeEvent.CALCULATE_SURFACE_AREA]: number;
	[ThreeEvent.ZOOM_LEVEL]: number;
	[ThreeEvent.DISTANCE]: number;
	[ThreeEvent.IS_DRAWING]: boolean;
	[ThreeEvent.SET_MEASUREMENTS]: CreatorMeasurement[];
	[ThreeEvent.CONTEXT_MENU]: ModuleContextMenuData;
};

export type SerializedRenderer = {
	projectPlane: SerializedProjectPlane;
	playgroundManger: SerializedPlaygroundManager;
	modulesManger: SerializedModulesManager;
	measurementManager: SerializedMeasurementManager;
	cameraController: SerializedCameraController;
};

export interface CollidableObjectSerializeData {
	collisionsEnabled: boolean;
	isCorrect: boolean;
	position: Vector2Tuple;
	rotation: number;
	collidedModules: UUID[];
}

export enum RotationDirection {
	CLOCKWISE = 'cw',
	COUNTER_CLOCKWISE = 'ccw',
}
